import React from 'react';
import { SectionHeader } from '@components/SectionHeader/SectionHeader';
import { HeroWithSubHeroType, SplashHeroType } from '@appTypes/CategoryAppType';
import { HeroWithSubHero } from './HeroWithSubHero/HeroWithSubHero';
import { HeroWithTitleAndWideImage, HeroWithTitleAndWideImageType } from './HeroWithTitleAndWideImage';

interface Props {
  hero?: SplashHeroType | HeroWithSubHeroType | HeroWithTitleAndWideImageType;
}
export const Hero = ({ hero }: Props) => (
  // TODO: Update the object from elbil app in api to be flat, all keys directly under hero.
  <>
    {hero.heroVariant === 'splashHero' && (
      <SectionHeader
        title={hero.title || hero.splashHero.title} // these handle the object from elbil app
        ingress={hero.ingress || hero.splashHero.ingress || undefined}
      />
    )}
    {hero.heroVariant === 'heroWithSubHero' && <HeroWithSubHero name={hero.title} heroWithSubHero={hero} />}
    {hero.heroVariant === 'heroWithTitleAndWideImage' && <HeroWithTitleAndWideImage hero={hero} />}
  </>
);
